import React from 'react'
import { Juliet } from 'component-library/collections-new/Juliet/Juliet'
import { ContentDataDefinitionLoader } from 'common/data/loader-definitions'
import {
    CollectionRouteProps,
    calculateExpectedCardCountFromContentData,
} from 'component-library/collections-new/collections-props.routing'
import { LoadMore } from 'component-library/collections-new-loadmore/LoadMore/LoadMore'
import { LoadMoreProps } from 'component-library/collections-new-loadmore/LoadMore/LoadMore'
import { LandscapeLayout } from 'component-library/cards/Landscape/Landscape.layouts'
import { MediaMode } from 'component-library/cards/CardMedia/CardMedia'
import { createRegisterableComponentWithData } from 'common/routing/page-definition'
import { CardBreakpointRatios, FixedRatio } from 'common/client-data-types/image-item'
import { TimestampType } from 'component-library/content/CardTimestamp/CardTimestamp'

export interface JulietRouteProps extends CollectionRouteProps, LoadMoreProps {
    hideKicker?: boolean
    hideTeaser?: boolean
    hideByline?: boolean
    showLargeCard?: boolean
    timestamp?: TimestampType
    cardType: LandscapeLayout | 'LandscapeWide'
    fixedRatios?: FixedRatio | FixedRatio[] | CardBreakpointRatios
    removeHorizontalGutters?: boolean
    disableImageLazyLoad?: boolean
    stickyOffset?: number | undefined
    mediaMode?: MediaMode
    contentIsTangential?: boolean
}

export const JulietRegistration = createRegisterableComponentWithData(
    'juliet',
    ContentDataDefinitionLoader,
    (props: JulietRouteProps, data, services) => {
        return (
            <LoadMore
                dataDefinition={data.dataDefinitionArgs}
                services={services}
                loadMoreEnabled={props.loadMoreEnabled === true}
                data={data}
                render={loadMoreData => {
                    return (
                        <Juliet
                            items={
                                loadMoreData.loaded
                                    ? { loaded: true, result: loadMoreData.result.publications }
                                    : { loaded: false }
                            }
                            expectedCards={calculateExpectedCardCountFromContentData(
                                data.dataDefinitionArgs
                            )}
                            sectionHeader={props.sectionHeader}
                            hideKicker={props.hideKicker}
                            hideTeaser={props.hideTeaser}
                            hideByline={props.hideByline}
                            fixedRatios={props.fixedRatios}
                            cardType={props.cardType}
                            showLargeCard={props.showLargeCard}
                            timestamp={props.timestamp}
                            removeHorizontalGutters={props.removeHorizontalGutters}
                            verticalSpacing={props.verticalSpacing}
                            disableImageLazyLoad={props.disableImageLazyLoad}
                            onEvent={services.onEvent}
                            mediaMode={props.mediaMode}
                            contentIsTangential={props.contentIsTangential}
                        />
                    )
                }}
            />
        )
    }
)
